const modulePages = [
	{
		id: 'm1-page-1',
		isFacilitatorOnly: true,
		title: 'DET, VI TROR, DE ANDRE TÆNKER',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				type: 'video',
				videoType: 'ignite',
				text: 'SE VIDEO',
				videoLink: 'https://kfs.euvideocdn.com/player/index.html?id=6a425fc0ac55558c81793d83'
			},
		],
		minigames: []
	},
	{
		id: 'm1-page-2',
		isFacilitatorOnly: true,
		title: 'HVAD ER DEN SVÆRE CIRKEL?',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				type: 'video',
				videoType: 'ignite',
				text: 'SE VIDEO',
				videoLink: 'https://kfs.euvideocdn.com/player/index.html?id=6a426013ac55558c8179419b '
			},
			{
				id: 'cirkel',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'm1-ovelse1',
				type: 'image',
				text: 'ØVELSE - DEL 1'
			},
			{
				id: 'm1-ovelse2',
				type: 'image',
				text: 'ØVELSE - DEL 2'
			},
		],
		minigames: []
	},
	{
		id: 'm1-page-3',
		isFacilitatorOnly: true,
		title: 'NÅR DET GÅR I RING',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm1-send-aben-videre',
				type: 'image', 
				text: 'ØVELSE'
			},
			{
				id: 'm1-eksempel',
				type: 'image',
				text: 'EKSEMPEL'
			},
			{
				id: 'm1-basalboksen',
				type: 'image',
				text: 'BASALBOXEN'
			},
			{
				id: 'm1-slide',
				type: 'image',
				text: 'SLIDE'
			}
		],
		minigames: []
	}
];


export {
	modulePages
};